// src/components/ui/FloatingActionButton.tsx
import { MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export default function FloatingActionButton() {
  const handleContactUsClick = () => {
    const win = window as any;

    // This function attempts to initialize (if not already) and open the feedback widget.
    // Returns true if successful or already initialized and action for opening is posted, false otherwise.
    const tryInitializeAndOpenFeedbackWidget = () => {
      if (typeof win.Featurebase === 'function' && !(win.Featurebase as any).q) {
        // Initialize the feedback widget if it hasn't been already.
        // We use a specific flag for the feedback widget to avoid conflicts
        // if other Featurebase widgets have their own initialization.
        if (!win.__feedback_widget_initialized) {
          win.Featurebase('initialize_feedback_widget', {
            organization: 'scheduleheroai', // Your Featurebase organization ID
            theme: 'light',
            locale: 'en',
          });
          win.__feedback_widget_initialized = true; // Mark as initialized
        }
        
        // After ensuring initialization (or if already initialized), post a message to open the widget.
        win.postMessage(
          {
            target: 'FeaturebaseWidget',
            data: { action: 'openFeedbackWidget' },
          },
          '*'
        );
        return true; // Successfully initialized (or was already) and message posted
      }
      return false; // Featurebase SDK not ready
    };

    if (!tryInitializeAndOpenFeedbackWidget()) {
      // If SDK not ready, set up an interval to retry for a short period.
      let attempts = 0;
      const maxAttempts = 10; // Try for 2 seconds (10 attempts * 200ms interval)
      const intervalId = setInterval(() => {
        attempts++;
        if (tryInitializeAndOpenFeedbackWidget() || attempts >= maxAttempts) {
          clearInterval(intervalId);
          if (attempts >= maxAttempts && !tryInitializeAndOpenFeedbackWidget()) {
            const isSDKReady = typeof win.Featurebase === 'function' && !(win.Featurebase as any).q;
            if (!isSDKReady) {
               console.error("Featurebase SDK did not become available after multiple attempts for FAB.");
            } else if (!win.__feedback_widget_initialized) {
               console.error("Failed to initialize Featurebase feedback widget after multiple attempts for FAB.");
            } else {
               console.error("Failed to trigger open for Featurebase feedback widget despite SDK being ready and initialized for FAB.");
            }
          }
        }
      }, 200);
    }
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="default" // Or your primary button variant
            className="fixed bottom-6 right-6 h-14 w-14 rounded-full shadow-lg z-50 flex items-center justify-center"
            onClick={handleContactUsClick}
            aria-label="Contact Us or give Feedback"
          >
            <MessageSquare className="h-6 w-6" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="left">
          <p>Contact Us / Feedback</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}